import { render, staticRenderFns } from "./SoundEditor.vue?vue&type=template&id=2dc4fda8&scoped=true&"
import script from "./SoundEditor.vue?vue&type=script&lang=js&"
export * from "./SoundEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc4fda8",
  null
  
)

export default component.exports